import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { BUTTON_SX } from '~/theme';

/**
 * Makes the export button read as the menu it is, matching the views control at the other
 * end of the toolbar. Shared so the default export and the per-table custom ones agree.
 */
export const EXPORT_BUTTON_SLOT_PROPS = {
  button: {
    variant: 'outlined' as const,
    endIcon: <ArrowDropDownIcon />,
    sx: BUTTON_SX,
  },
};
